<template>
  <NewsletterRegistrationComponent
    :action-id="content?.actionId"
    :background-color="content?.backgroundColor"
    :benefits="content?.benefits"
    :confirmation-headline="content?.confirmationHeadline"
    :confirmation-steps="content?.confirmationSteps"
    :confirmation-subline="content?.confirmationSubline"
    :dot-pattern="content?.dotPattern"
    :email="email"
    :image="content?.image"
    :image-first="content?.imageFirst"
    :information-headline="content?.informationHeadline"
    :information-steps="content?.informationSteps"
    :information-subline="content?.informationSubline"
    :interaction-id="content?.interactionId"
    :registration-headline="content?.registrationHeadline"
    :registration-subline="content?.registrationSubline"
    :skip-doi="skipDoi"
  />
</template>

<script setup>
import NewsletterRegistrationComponent from "~/templates/components/cms/NewsletterRegistrationComponent.vue";

defineProps(["content", "email", "skipDoi"]);
</script>
